module.exports = __webpack_public_path__ + "img/protocolAttacks.a597e58.svg";